import { createSlice } from "@reduxjs/toolkit";


export const carrouselSlice = createSlice({
  name: 'carrousel',
  initialState: {
    visible: false,
    selected: false,
    images: [],
  },
  reducers: {
    setImages: (state, action) => {
      state.images = action.payload;
    },
    hideCarrousel: (state, action) => {
      document.body.classList.remove('modal-open');
      state.visible = false;
    },
    showCarrousel: (state, action) => {
      if(action.payload) {
        state.selected = action.payload;
      } else {
        state.selected = false;
      }
      document.body.classList.add('modal-open');
      state.visible = true;
    },
  }
})

// Action creators are generated for each case reducer function
export const { setImages, hideCarrousel, showCarrousel } = carrouselSlice.actions
//
export default carrouselSlice.reducer
